/* eslint-disable import/no-default-export */
import {ProductPageController} from '../../productPage/viewerScript/ProductPageController';

export default ProductPageController;
